var render = function render(){var _vm=this,_c=_vm._self._c;return _c('eg-b-form-checkbox-group',{staticClass:"export-options mt-2 bv-no-focus-ring",attrs:{"checked":_vm.value,"options":_vm.options,"name":"export-options","stacked":_vm.stacked},on:{"change":_vm.handleExportChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }